// Translations
import landing from '../views/landing/translations/en'

// Translation: Login (English)
export default Object.freeze({
	name: 'Login',
	views: { landing }
})
